import { environment } from "./environments/environment";

export class configuration {
    static REQUEST = {
        POST: "post",
        PATCH: "patch",
        PUT: "put",
        DELETE: "delete",
        GET: "get"
    }

    // Local storage names
    static LOCAL_STORAGE = {
        USER_TOKEN: "token",
        USER_EMAIL: "email",
        USER_NAME: "name",
        USER_ID: "id",
        USER_PHONE: "phone",
        USER_TYPE: "user_type",
    }

    static EMIRATES = [
        { id: 1, image: "assets/images/img-1.png", city: "Dubai" },
        { id: 2, image: "assets/images/img-2.png", city: "Abu Dhabi" },
        { id: 3, image: "assets/images/img-3.png", city: "Sharjah" },
        { id: 4, image: "assets/images/img-4.png", city: "Ras Al Khaimah" },
        { id: 5, image: "assets/images/img-5.png", city: "Ajman" },
        { id: 6, image: "assets/images/img-6.png", city: "Umm Al Quwain" },
        { id: 7, image: "assets/images/img-7.png", city: "Fujairah" },
      ]

    static IMAGE_URL = environment.IMAGE_URL;

    static previewFileExtensions = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'mp4', 'mov', 'mpeg', 'mp3'];

    static ENDPOINT = {
        CREATE_PROPERTY_STEP1: 'seller/create-property-step1',
        CREATE_PROPERTY_STEP2: 'seller/create-property-step2',
        CREATE_PROPERTY_STEP3: 'seller/create-property-step3',
        CREATE_PROPERTY_STEP4: 'seller/create-property-step4',
        CREATE_PROPERTY_STEP5: 'seller/create-property-step5',
        CREATE_PROPERTY_STEP6: 'seller/create-property-step6',
        CITY_LIST :'common/city-list',
        COMMON_GET_DATA_BY_WHERE :'common/get-data-by-where',
        LANDMARK_LIST_CITY_WISE :'common/landmark-list',
        PROPERTY_LIST : 'buyer/property-list',
        MY_PROPERTY_LIST : 'buyer/my-property-list',
        PROPERTY_LIST_COUNT_LANDMARK : 'buyer/landmark-wise-property-count',
        PROPERTY_LIST_COUNT_CITY : 'buyer/city-wise-property-count',
        BUYER_REGISTRATION: "buyer/buyer-registration",
        SELLER_REGISTRATION: "seller/seller-registration",
        SELLER_REGISTRATION_CHECK: "seller/seller-registration-check",
        BUYER_LOGIN : 'buyer/buyer-login',
        SELLER_LOGIN : 'seller/seller-login',
        FAVOURITE_PROPERTY: 'seller/mark-unmark-favourite-property',
        INQUIRY_LIST: "seller/get-property-inquiries",
        PROPERTY_VIEW: "seller/property-view",
        CAN_POST_PROPERTY: "payment/can-post-property",
        CAN_VIEW_PROPERTY: "payment/get-property-contact-details",
        ADD_CONTACTED_PROPERTY: "seller/add-contacted-property",
        CONTACT_US: "buyer/contact-us",
        MORTAGAGE_ADD: "seller/add-mortgage",
        UPDATE_IS_ALL_STEP_COMPLETE: 'seller/update-is-all-step-complete',
        UPLOAD_BROCHURE: 'seller/upload-brochure',
        ASSISTED_PLANS : 'seller/add-assisted-plans',
        CHANGE_PASSWORD : 'seller/change-password',
        RESET_PASSWORD : 'seller/reset-password',
        SET_PASSWORD : 'seller/set-password',
        FORGOT_PASSWORD : 'seller/forgot-password',
        ADD_SUBSCRIPTION_PLAN : 'common/add-subscription',
        UPLOAD_DEED_IMAGES : 'seller/upload-deed-images',
        UPLOAD_FLOOR_IMAGES : 'seller/upload-floor-plan',
        ADD_PROPERY_VALUE_APPROXIMATION : 'seller/add-property-value-approximation',
        UPLOAD_PROPERY_VALUE_APPROXIMATION_AREA : 'seller/upload-property-value-approximation-area-photos',
        UPLOAD_PROPERY_VALUE_APPROXIMATION_TITLE_DEED : 'seller/upload-property-value-approximation-title-deed',
        UPLOAD_PROPERY_VALUE_APPROXIMATION_FLOOR_PLAN : 'seller/upload-property-value-approximation-floor-plan',
        CHECK_FAVOURITE_PROPERTY: 'seller/is-favourite-property-list',
        PROPERTY_TYPE_DATA : 'common/property-type-data',
        SELLER_OTP_VERIFICATION: "seller/verify-otp",
        UPDATE_PROFILE : "seller/update-profile",
        GET_USER_DATA : 'seller/get-user-data',
        // Property Value Approximation
        CONTACTED_PROPERTY_LIST: 'seller/contacted-property-list',
        FAVOURITE_PROPERTY_LIST: 'buyer/favourite-property-list',
        UPDATE_PROPERTY_STEP1: 'seller/update-property-step1/',
        DELETE_PROPERTY_IMAGE: 'seller/delete-image',
        DELETE_DEED: 'seller/delete-title-deed',
        DELETE_BROCHURE: 'seller/delete-brochure',
        DELETE_FLOOR_PLAN: 'seller/delete-floor-plan',
        ADD_CAREER : 'common/add-career',
        GET_LOCATION_DATA : 'common/get-location-details',
        GET_LOCATION_TEXT_AREA_DATA : 'common/get-location-details-text-area',
        SEND_FORGOT_PASSWORD_MAIL : "seller/forgot-password-mail",
        DELETE_SELLER : "seller/delete-seller",
        DELETE_PROPERTY : "seller/delete-property",
        CREATE_SESSION : 'payment/create-session',
        CHECK_STATUS : 'payment/check-status',
        COMMON_PDF : 'pdf/common',
        GET_INVOICE_DATA : 'payment/get-invoice-data',
        GET_PAYMENT_REQUEST_DATA : 'payment/get-payment-request-data',
        UPDATE_PROPERTY_COUNT: 'seller/update-post-property-count',
        // FETCH_INVOICE_DATA : 'payment/check-status',
        GET_DEVELOPER_BY_ID: 'buyer/get-developer-by-id',
        GET_DEVELOPER_ALL: 'buyer/get-all-developers',
        GET_DEVELOPER: 'buyer/get-all-developers-for-list-page',
        GET_REVIEWS: 'buyer/get-homepage-reviews',
        GET_REVIEWS_BY_ID: 'buyer/get-review-by-id',
        GET_HOMEPAGE_PODCAST: 'buyer/get-homepage-podcast',
        ADD_USER_REVIEW: 'buyer/add-user-review',
        GET_APPROVED_REVIEW: 'buyer/get-appove-review',
        VALIDATE_DISCOUNT: 'buyer/validate-discount',
        ADD_INQUIRY: 'seller/add-inquiry',
        GET_PROPERTY_CONTACT: 'buyer/get-property-contact'


    }
    static TABLE = {

    }

    static propertyImageCategory = [
        { "id": 1, "name": "Entrance" },
        { "id": 2, "name": "Living Room" },
        { "id": 3, "name": "Kitchen" },
        { "id": 4, "name": "Bedroom1" },
        { "id": 5, "name": "Bedroom2" },
        { "id": 6, "name": "Bedroom3" },
        { "id": 7, "name": "Bedroom4" },
        { "id": 8, "name": "Bedroom5" },
        { "id": 9, "name": "Bedroom6" },
        { "id": 10, "name": "Bedroom7" },
        { "id": 11, "name": "Bedroom7+" },
        { "id": 12, "name": "Washroom" },
        { "id": 13, "name": "Brochure Layout" },
        { "id": 14, "name": "Community" },
        { "id": 15, "name": "Other" }
    ];

    static cityList = [
        { "id": 1, "name": "Abu Dhabi" },
        { "id": 2, "name": "Dubai" },
        { "id": 3, "name": "Sharjah" },
        { "id": 4, "name": "Ajman" },
        { "id": 5, "name": "Umm Al Quwain" },
        { "id": 6, "name": "Ras Al Khaimah" },
        { "id": 7, "name": "Fujairah" }
    ];
    
    static countries = [
        { name: 'Afghanistan', code: 'AF' },
        { name: 'Albania', code: 'AL' },
        { name: 'Algeria', code: 'DZ' },
        { name: 'Andorra', code: 'AD' },
        { name: 'Angola', code: 'AO' },
        { name: 'Antigua and Barbuda', code: 'AG' },
        { name: 'Argentina', code: 'AR' },
        { name: 'Armenia', code: 'AM' },
        { name: 'Australia', code: 'AU' },
        { name: 'Austria', code: 'AT' },
        { name: 'Azerbaijan', code: 'AZ' },
        { name: 'Bahamas', code: 'BS' },
        { name: 'Bahrain', code: 'BH' },
        { name: 'Bangladesh', code: 'BD' },
        { name: 'Barbados', code: 'BB' },
        { name: 'Belarus', code: 'BY' },
        { name: 'Belgium', code: 'BE' },
        { name: 'Belize', code: 'BZ' },
        { name: 'Benin', code: 'BJ' },
        { name: 'Bhutan', code: 'BT' },
        { name: 'Bolivia (Plurinational State of)', code: 'BO' },
        { name: 'Bosnia and Herzegovina', code: 'BA' },
        { name: 'Botswana', code: 'BW' },
        { name: 'Brazil', code: 'BR' },
        { name: 'Brunei Darussalam', code: 'BN' },
        { name: 'Bulgaria', code: 'BG' },
        { name: 'Burkina Faso', code: 'BF' },
        { name: 'Burundi', code: 'BI' },
        { name: 'Cabo Verde', code: 'CV' },
        { name: 'Cambodia', code: 'KH' },
        { name: 'Cameroon', code: 'CM' },
        { name: 'Canada', code: 'CA' },
        { name: 'Central African Republic', code: 'CF' },
        { name: 'Chad', code: 'TD' },
        { name: 'Chile', code: 'CL' },
        { name: 'China', code: 'CN' },
        { name: 'Colombia', code: 'CO' },
        { name: 'Comoros', code: 'KM' },
        { name: 'Congo', code: 'CG' },
        { name: 'Congo, Democratic Republic of the', code: 'CD' },
        { name: 'Costa Rica', code: 'CR' },
        { name: 'Croatia', code: 'HR' },
        { name: 'Cuba', code: 'CU' },
        { name: 'Cyprus', code: 'CY' },
        { name: 'Czechia', code: 'CZ' },
        { name: 'Denmark', code: 'DK' },
        { name: 'Djibouti', code: 'DJ' },
        { name: 'Dominica', code: 'DM' },
        { name: 'Dominican Republic', code: 'DO' },
        { name: 'Ecuador', code: 'EC' },
        { name: 'Egypt', code: 'EG' },
        { name: 'El Salvador', code: 'SV' },
        { name: 'Equatorial Guinea', code: 'GQ' },
        { name: 'Eritrea', code: 'ER' },
        { name: 'Estonia', code: 'EE' },
        { name: 'Eswatini', code: 'SZ' },
        { name: 'Ethiopia', code: 'ET' },
        { name: 'Fiji', code: 'FJ' },
        { name: 'Finland', code: 'FI' },
        { name: 'France', code: 'FR' },
        { name: 'Gabon', code: 'GA' },
        { name: 'Gambia', code: 'GM' },
        { name: 'Georgia', code: 'GE' },
        { name: 'Germany', code: 'DE' },
        { name: 'Ghana', code: 'GH' },
        { name: 'Greece', code: 'GR' },
        { name: 'Grenada', code: 'GD' },
        { name: 'Guatemala', code: 'GT' },
        { name: 'Guinea', code: 'GN' },
        { name: 'Guinea-Bissau', code: 'GW' },
        { name: 'Guyana', code: 'GY' },
        { name: 'Haiti', code: 'HT' },
        { name: 'Honduras', code: 'HN' },
        { name: 'Hungary', code: 'HU' },
        { name: 'Iceland', code: 'IS' },
        { name: 'India', code: 'IN' },
        { name: 'Indonesia', code: 'ID' },
        { name: 'Iran (Islamic Republic of)', code: 'IR' },
        { name: 'Iraq', code: 'IQ' },
        { name: 'Ireland', code: 'IE' },
        { name: 'Israel', code: 'IL' },
        { name: 'Italy', code: 'IT' },
        { name: 'Jamaica', code: 'JM' },
        { name: 'Japan', code: 'JP' },
        { name: 'Jordan', code: 'JO' },
        { name: 'Kazakhstan', code: 'KZ' },
        { name: 'Kenya', code: 'KE' },
        { name: 'Kiribati', code: 'KI' },
        { name: 'Korea (Democratic People\'s Republic of)', code: 'KP' },
        { name: 'Korea, Republic of', code: 'KR' },
        { name: 'Kuwait', code: 'KW' },
        { name: 'Kyrgyzstan', code: 'KG' },
        { name: 'Lao People\'s Democratic Republic', code: 'LA' },
        { name: 'Latvia', code: 'LV' },
        { name: 'Lebanon', code: 'LB' },
        { name: 'Lesotho', code: 'LS' },
        { name: 'Liberia', code: 'LR' },
        { name: 'Libya', code: 'LY' },
        { name: 'Liechtenstein', code: 'LI' },
        { name: 'Lithuania', code: 'LT' },
        { name: 'Luxembourg', code: 'LU' },
        { name: 'Madagascar', code: 'MG' },
        { name: 'Malawi', code: 'MW' },
        { name: 'Malaysia', code: 'MY' },
        { name: 'Maldives', code: 'MV' },
        { name: 'Mali', code: 'ML' },
        { name: 'Malta', code: 'MT' },
        { name: 'Marshall Islands', code: 'MH' },
        { name: 'Mauritania', code: 'MR' },
        { name: 'Mauritius', code: 'MU' },
        { name: 'Mexico', code: 'MX' },
        { name: 'Micronesia (Federated States of)', code: 'FM' },
        { name: 'Moldova, Republic of', code: 'MD' },
        { name: 'Monaco', code: 'MC' },
        { name: 'Mongolia', code: 'MN' },
        { name: 'Montenegro', code: 'ME' },
        { name: 'Morocco', code: 'MA' },
        { name: 'Mozambique', code: 'MZ' },
        { name: 'Myanmar', code: 'MM' },
        { name: 'Namibia', code: 'NA' },
        { name: 'Nauru', code: 'NR' },
        { name: 'Nepal', code: 'NP' },
        { name: 'Netherlands', code: 'NL' },
        { name: 'New Zealand', code: 'NZ' },
        { name: 'Nicaragua', code: 'NI' },
        { name: 'Niger', code: 'NE' },
        { name: 'Nigeria', code: 'NG' },
        { name: 'North Macedonia', code: 'MK' },
        { name: 'Norway', code: 'NO' },
        { name: 'Oman', code: 'OM' },
        { name: 'Pakistan', code: 'PK' },
        { name: 'Palau', code: 'PW' },
        { name: 'Panama', code: 'PA' },
        { name: 'Papua New Guinea', code: 'PG' },
        { name: 'Paraguay', code: 'PY' },
        { name: 'Peru', code: 'PE' },
        { name: 'Philippines', code: 'PH' },
        { name: 'Poland', code: 'PL' },
        { name: 'Portugal', code: 'PT' },
        { name: 'Qatar', code: 'QA' },
        { name: 'Romania', code: 'RO' },
        { name: 'Russian Federation', code: 'RU' },
        { name: 'Rwanda', code: 'RW' },
        { name: 'Saint Kitts and Nevis', code: 'KN' },
        { name: 'Saint Lucia', code: 'LC' },
        { name: 'Saint Vincent and the Grenadines', code: 'VC' },
        { name: 'Samoa', code: 'WS' },
        { name: 'San Marino', code: 'SM' },
        { name: 'Sao Tome and Principe', code: 'ST' },
        { name: 'Saudi Arabia', code: 'SA' },
        { name: 'Senegal', code: 'SN' },
        { name: 'Serbia', code: 'RS' },
        { name: 'Seychelles', code: 'SC' },
        { name: 'Sierra Leone', code: 'SL' },
        { name: 'Singapore', code: 'SG' },
        { name: 'Slovakia', code: 'SK' },
        { name: 'Slovenia', code: 'SI' },
        { name: 'Solomon Islands', code: 'SB' },
        { name: 'Somalia', code: 'SO' },
        { name: 'South Africa', code: 'ZA' },
        { name: 'South Sudan', code: 'SS' },
        { name: 'Spain', code: 'ES' },
        { name: 'Sri Lanka', code: 'LK' },
        { name: 'Sudan', code: 'SD' },
        { name: 'Suriname', code: 'SR' },
        { name: 'Sweden', code: 'SE' },
        { name: 'Switzerland', code: 'CH' },
        { name: 'Syrian Arab Republic', code: 'SY' },
        { name: 'Tajikistan', code: 'TJ' },
        { name: 'Tanzania, United Republic of', code: 'TZ' },
        { name: 'Thailand', code: 'TH' },
        { name: 'Timor-Leste', code: 'TL' },
        { name: 'Togo', code: 'TG' },
        { name: 'Tonga', code: 'TO' },
        { name: 'Trinidad and Tobago', code: 'TT' },
        { name: 'Tunisia', code: 'TN' },
        { name: 'Turkey', code: 'TR' },
        { name: 'Turkmenistan', code: 'TM' },
        { name: 'Tuvalu', code: 'TV' },
        { name: 'Uganda', code: 'UG' },
        { name: 'Ukraine', code: 'UA' },
        { name: 'United Arab Emirates', code: 'UAE' },
        { name: 'United Kingdom of Great Britain and Northern Ireland', code: 'GB' },
        { name: 'United States of America', code: 'US' },
        { name: 'Uruguay', code: 'UY' },
        { name: 'Uzbekistan', code: 'UZ' },
        { name: 'Vanuatu', code: 'VU' },
        { name: 'Venezuela (Bolivarian Republic of)', code: 'VE' },
        { name: 'Viet Nam', code: 'VN' },
        { name: 'Yemen', code: 'YE' },
        { name: 'Zambia', code: 'ZM' },
        { name: 'Zimbabwe', code: 'ZW' }
    ];
    
    static REVIEWS = {
        location_convenience: {
            1: "Pack a lunch, it’s an expedition.",
            2: "You’ll make it, but stock up on podcasts.",
            3: "Reasonably reachable if you like long drives.",
            4: "Close enough to consider Ubering occasionally.",
            5: "Blink and you’re downtown—perfect for the chronically late."
        },
        curb_appeal: {
            1: "More filters than a coffee shop required.",
            2: "Looks better at night… with strategic lighting.",
            3: "You’ll take a pic, but add some creative angles.",
            4: "Will inspire envy on social media.",
            5: "Instant influencer status—no filter needed."
        },
        amenities: {
            1: "Your fridge is your only amenity.",
            2: "Gym… but only if you call two treadmills a gym.",
            3: "Pool, gym, maybe a tennis court on a good day.",
            4: "Resort vibes—fitness, relaxation, the works!",
            5: "It’s practically a vacation home—minus the annoying tourists."
        },
        neighborhood_vibes: {
            1: "Everyone’s a ghost. You’re not sure anyone lives here.",
            2: "You might see someone occasionally… like spotting Bigfoot.",
            3: "Wave at your neighbors—don’t ask their names, though.",
            4: "Friendly waves, barbecues, and the occasional chit-chat.",
            5: "You’re in the cast of a suburban sitcom—everyone’s friends."
        },
        greenery: {
            1: "Green? Do you mean the color of my envy for real grass?",
            2: "A few plants here and there, if you squint.",
            3: "Enough to know that someone owns a lawnmower.",
            4: "A garden where you may get lost for a second.",
            5: "You’ve moved to a botanical paradise."
        },
        construction: {
            1: "You gotta practically wear a helmet in the house.",
            2: "You’ll see a few cracks in the wall... very soon.",
            3: "Some money to be kept aside for renovating in a few years.",
            4: "Strong enough, neighbors can't listen to what's happening inside.",
            5: "Worth every penny."
        },
        investment_potential: {
            1: "You’re basically paying for a view of the desert.",
            2: "Might break even—if you’re lucky.",
            3: "Safe bet for long-term growth.",
            4: "You’ll be able to cash out when the time’s right.",
            5: "You’re sitting on a gold mine—cha-ching!"
        },
    }


    static PAGE_LIMIT = 20;
    static OFFSET = 0;

    static IMAGE_EXTENSION = ["jpg", "png", "gif"];

}